@for (category of dataRef; track category) {
  <div class="p-field-checkbox">
    <p-checkbox name="group2" value="category" [value]="category"  [(ngModel)]="value" [inputId]="category.key" ></p-checkbox>
    <label [for]="category.key">{{category.value}}</label>
  </div>
}
